import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import CarouselParceiros from "./CarouselParceiros";
import api from "../service/api";

export default function Parceiros() {
  const classes = useStyles();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api
      .get("/sponsors")
      .then((response) => setPartners(Array.isArray(response.data.data) ? response.data.data : []))
      .catch(e => console.log("Erro ao buscar parceiros:", e.message));
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { partners.length <= 1 ? (
          partners?.map((patrocinador, index) => (
            <div>
              <a href={`${patrocinador.website}`}
              target="_blank"
              rel="noopener noreferrer"
              >
                <img
                  key={patrocinador}
                  src={patrocinador.logo || patrocinador.image_url}
                  alt="Patrocinador"
                  className={classes.patrocinador}
                />
              </a>
            </div>
          ))
        ) : (
          <CarouselParceiros partners={partners} />
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "55px",
    marginRight: "25px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  content: {
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    gap: "16px",
  },
  patrocinador: {
    width: "100%",
    maxWidth: "280px",
    maxHeight: "180px",
    objectFit: "contain",
  },
}));
